export const timeFormatConfig = {
  'HH:mm': {
    timeDisplayFormat: 'HH:mm' /* 16:15 */
  },
  'h:mm a': {
    timeDisplayFormat: 'h:mm A' /* 4:15 AM */
  }
};

export const timeFormatOptions = ['HH:mm', 'h:mm a'];
export const defaultTimeFormat = 'HH:mm';
